import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export type Role = "user" | "admin";

export interface Billing {
  status: "exempt" | "none" | "trialing" | "active" | "canceling" | "past_due" | "expired";
  access: "full" | "readonly" | "none" | "ended";
  plan_interval?: "monthly" | "annual" | null;
  current_period_end?: string | null;
  trial_end?: string | null;
  grace_end?: string | null;
  trial_used?: boolean;
  pending_plan_interval?: "monthly" | "annual" | null;
  pending_change_at?: string | null;
}

export interface BillingMe extends Billing {
  plans: { monthly: number; annual?: number };
  currency: string;
  mentor_limit: number;
  guarantee: { available: boolean; until: string | null; amount: number | null; status: "refunded" | "refund_failed" | null };
}

export interface User {
  id: string;
  name: string;
  email: string;
  role: Role;
  is_active: boolean;
  last_login_at: string | null;
  created_at: string;
  billing?: Billing;
  legal?: { terms_version: string; privacy_version: string; pending: boolean };
  setup_pending?: boolean;
}

export interface AppSettings {
  mentor_monthly_limit_default: number;
  mentor_hourly_limit_default: number;
  mentor_question_max_chars: number;
  mentor_response_max_tokens: number;
  daily_ai_budget_usd: number;
  mentor_system_prompt: string;
  admin_alert_email: string;
  grace_period_days_after_failed_payment: number;
  terms_version: string;
  privacy_version: string;
  updated_at?: string;
}

export interface AdminUserRow {
  id: string;
  is_internal?: boolean;
  name: string;
  email: string;
  role: Role;
  created_at: string;
  password_set: boolean;
  subscription_status: string | null;
  mentor_stage: "puppy" | "adult";
  counts: Record<string, number>;
  mentor: { messages_used_month: number; estimated_cost_total: number };
}

export function formatApiError(err: unknown): string {
  const detail = axios.isAxiosError(err) ? err.response?.data?.detail : undefined;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  }
  return "Algo salió mal. Intenta de nuevo.";
}
